import en_us from "./enResources";
import es_es from "./esResources";
import fr_fr from "./frResources";
import ja_jp from "./jaResources";

/**
 * NOTE:  Register any new locales in DateInput.tsx
 * The locale defaults to en_us if a specific locale is not registered with the DatePicker. 
 */
export const resourceMap: Record<string, Record<string, any>> = {
    en_us,
    fr_fr,
    es_es,
    ja_jp
}
